/**
 * Group-queue filter params. [IT-744, converged by IT-707 P2.1]
 *
 * IT-744 extracted this so the group-mode queue (photoGroups.js fetchGroups) and
 * the box-tagging queue (boxes.js fetchBoxGroup) could not drift. IT-707 P2.1 was
 * extracting the same mapping at the same time, for all four backend surfaces, as
 * `@/components/filters/capabilities`. Two independent extractions of one concern,
 * landed days apart — which is the duplication IT-707 exists to remove, so this
 * delegates rather than reimplementing.
 *
 * Kept as a module so IT-744's callers and spec need no change. P2.2 retires it
 * and points `boxes.js` straight at the capability builder.
 */
import {buildQueryString} from '@/components/filters/capabilities'

/** URLSearchParams for the group-queue filter. Callers read .get()/.getAll(). */
export function buildGroupFilterParams(payload = {}) {
  return new URLSearchParams(buildQueryString(payload))
}

/** The endpoint path with the filter query string appended (empty filter -> bare path). */
export function groupQueueUrl(basePath, payload = {}) {
  const qs = buildQueryString(payload)
  return qs ? `${basePath}?${qs}` : basePath
}
